import React, { useState } from "react";
import Input from "../../../ui/Input/Input";
import Button from "../../../ui/Button/Button";

import "./AuthForm.css";

function AuthForm({ onSubmit, credentialsInvalid }) {
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [enteredConfirmPassword, setEnteredConfirmPassword] = useState("");

  const { email: emailIsInvalid, password: passwordIsInvalid } =
    credentialsInvalid;

  function updateInputValueHandler(inputType, e) {
    let enteredValue = e.target.value;
    switch (inputType) {
      case "email":
        setEnteredEmail(enteredValue);
        break;
      case "password":
        setEnteredPassword(enteredValue);
        break;
      case "confirmPassword":
        setEnteredConfirmPassword(enteredValue);
        break;
      default:
        break;
    }
  }

  function submitHandler() {
    onSubmit({
      email: enteredEmail,
      password: enteredPassword,
      confirmPassword: enteredConfirmPassword,
    });
  }

  return (
    <div className="container">
      <div>
        <Input
          label="Correo Electrónico"
          onUpdateValue={updateInputValueHandler.bind(this, "email")}
          value={enteredEmail}
          isInvalid={emailIsInvalid}
          autoCompleteType="off"
        />
        <Input
          label="Contraseña"
          onUpdateValue={updateInputValueHandler.bind(this, "password")}
          value={enteredPassword}
          isInvalid={passwordIsInvalid}
          type="password"
          autoCompleteType="off"
        />
        <div className="loginButtons">
          <Button onPress={submitHandler}>Iniciar sesión</Button>
        </div>
      </div>
    </div>
  );
}

export default AuthForm;
